import { Breakpoints, styled } from "@vw-marketing/us-components";

export const LiteratureDownloadablesWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static520};
      padding: ${theme.size.static500} ${theme.size.grid002} 0 ${theme.size.grid002};
      width: ${theme.size.grid024};

      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static450};
      }

      @media (min-width: ${Breakpoints.b960}px) {
        padding-top: ${theme.size.static400};
      }
    `;
  }}
`;

export const CardsGroup: any = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static100};
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.size.static450};
  padding-top: ${({ theme }) => theme.size.static400};
  width: 100%;

  grid-template-columns: 1fr;

  @media (min-width: ${Breakpoints.b560}px) {
    grid-template-columns: repeat(2, minmax(189px, 1fr));
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    grid-template-columns: repeat(3, minmax(287px, 1fr));
  }

  & [class^='CardWrapper-'],
  & [class*=' CardWrapper-'] {
    align-items: flex-start;
    align-self: stretch;
    gap: 0 !important;
    padding: 0 !important;
    max-width: 698px;
    width: 100%;
  }

  & [class^='StyledCardSection-'],
  & [class*=' StyledCardSection-'] {
    gap: 0 !important;
    padding: 0 !important;
  }
`;

export const CardTitleContainer: any = styled.div`
  ${({ theme, type }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static200};
      height: auto;
      padding: ${theme.size.static250};

      @media (min-width: ${Breakpoints.b560}px) {
        height: ${type && type === 'resources' ? 'auto' : '78px'};
        padding: ${theme.size.static300};
      }

      @media (min-width: 780px) and (max-width: 931px) {
        height: 75px;
      }

      @media (min-width: ${Breakpoints.b960}px) {
        height: auto;
        padding: ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        height: ${type && type === 'resources' ? 'auto' : '90px'};
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        height: auto;
      }
    `;
  }}
`;

export const CardInformationContainer: any = styled.div`
  ${({ theme, type }) => {
    return `
      display: flex;
      flex-direction: column;
      height: auto;
      flex: 1 0 0;
      padding: ${theme.size.static250};

      @media (min-width: ${Breakpoints.b560}px) {
        height: 240px;
        padding: ${theme.size.static300};
      }

      @media (min-width: 770px) and (max-width: 931px) {
        height: 205px;
      }

      @media (min-width: ${Breakpoints.b960}px) {
        height: 200px;
        padding: ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        height: 220px;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        height: ${type && type === 'resources' ? '295px' : '270px'};
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        height: 270px;
      }
    `;
  }}
`;

export const CardTitleWrapper: any = styled.div`
  display: flex;
  gap: 6px;
  justify-content: start;

  p {
    padding-top: 2px;
  }
`;

export const CardInformationListContainer: any = styled.div`
  ${({ theme }) => {
    return `
      color: #6A767D;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
      padding-top: ${theme.size.static150};
    `;
  }}
`;

export const CardDownloadLinkContainer: any = styled.div`
  ${({ theme }) => {
    return `
      height: 60px;
      padding: ${theme.size.static250};

      p {
        display: flex;
        align-items: center;
        gap: ${theme.size.static100};
      }

      @media (min-width: ${Breakpoints.b560}px) {
        height: 70px;
        padding: ${theme.size.static300};
      }

      @media (min-width: 770px) and (max-width: 931px) {
        padding: ${theme.size.static300} 10px ${theme.size.static300} 10px;
      }

      @media (min-width: ${Breakpoints.b960}px) {
        height: 80px;
        padding: ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        height: 90px;
      }
    `;
  }}
`;

export const ErrorMessageContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      gap: ${theme.size.static150};
      padding: ${theme.size.static250};
      height: 100%;
      align-items: flex-start;
    `;
  }}
`;

export const AlertIconWrapper = styled.div`
  color: red;
  fill: red;
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

export const ErrorMessage = styled.p`
  margin: 0;
  padding: 0;
  
  p {
    margin: 0;
    padding: 0;
  }
`;